
document.addEventListener('DOMContentLoaded', function () {
    const openModalButtons = document.querySelectorAll('.js-open-modal');
    const closeModalButtons = document.querySelectorAll('.js-close-modal');
    const modals = document.querySelectorAll('.custom_modal');

    openModalButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = button.getAttribute('data-modal');
            const modal = document.getElementById(modalId);
            modal.classList.add('active');
        });
    });

    closeModalButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = button.getAttribute('data-modal');
            const modal = document.getElementById(modalId);
            modal.classList.remove('active');
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
        });
    });

    modals.forEach((modal) => {
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.classList.remove('active');
                document.body.style.overflow = 'auto';
                document.body.style.paddingRight = '0px';
            }
        });
    });

    const searchBtn = document.getElementById('search-button');
    const input = document.getElementById('search-city');
    const output = document.getElementById('paketomati-lista');
    let odaberiPaketomatBtn = document.getElementById('odaberi-paketomat');
    let listaPaketomata = [];
    let loader = document.getElementById('loader');

    searchBtn.addEventListener('click', () => {
        const grad = input.value.trim();
        if (!grad) return;
        loader.style.display = 'block';
        fetch(
            'https://novexpert-paketomat-api.onrender.com/hp/fetch-points',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    facilityType: 'PAK',
                    nextWeek: 0,
                    searchText: grad,
                }),
            }
        )
            .then((res) => res.json())
            .then((data) => {
                const lista = data.paketomatInfoList;
                output.innerHTML = ''; // očisti prethodne

                if (!lista || lista.length === 0) {
                    output.innerHTML = '<p>Nema rezultata za uneti grad.</p>';
                    return;
                }

                const select = document.createElement('select');
                select.name = 'paketomatCode';
                select.required = true;
                select.style.width = '100%';
                select.style.padding = '10px';
                select.style.border = '1px solid #ccc';
                select.style.borderRadius = '5px';
                select.style.fontSize = '16px';
                select.style.fontFamily = 'Arial, sans-serif';
                select.style.resize = 'vertical';
                select.style.margin = '0 0 20px 0';
                select.classList.add('package-modal-selected');

                listaPaketomata = lista;

                lista.forEach((pak) => {
                    const option = document.createElement('option');
                    option.value = pak.code;
                    option.textContent = `${pak.name}, ${pak.address}, ${pak.city}`;
                    select.appendChild(option);
                });

                output.appendChild(select);

                // Dodaj event listener na select za praćenje promjena
                select.addEventListener('change', (e) => {
                });
                loader.style.display = 'none';
            });
    });
    odaberiPaketomatBtn.addEventListener("click", () => {
        let select = document.querySelector(".package-modal-selected");
        if (!select) return; // provera da li postoji select

        let selectedCode = select.value;
        let selectedPaketomat = listaPaketomata.find(p => p.code === selectedCode);
        if (selectedPaketomat) {
            const fullAddress = `${selectedPaketomat.name}, ${selectedPaketomat.address}, ${selectedPaketomat.zip} ${selectedPaketomat.city}`;
            // Prvo dobavi trenutnu korpu da bismo dobili line_items

            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    let cartItemsWithPaketomat = cart.items.map(item => ({
                        id: item.id,
                        quantity: item.quantity,
                        properties: {
                            ...item.properties,
                            'Paketomat_Code': selectedPaketomat.code,
                            'Paketomat_Address': fullAddress
                        }
                    }));

                    // First clear the cart
                    return fetch('/cart/clear.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    })
                        .then(response => response.json())
                        .then(emptyCart => {

                            // Then add items back with properties
                            return fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    items: cartItemsWithPaketomat,
                                    attributes: {
                                        'Paketomat_Code': selectedPaketomat.code,
                                        'Paketomat_Address': fullAddress
                                    }
                                })
                            });
                        });
                })
                .then(response => response.json())
                .then(updatedCart => {
                    // Ostatak koda ostaje isti
                    const infoDiv = document.getElementById('selected-paketomat-info');
                    const addressP = document.getElementById('selected-paketomat-address');
                    if (infoDiv && addressP) {
                        addressP.textContent = fullAddress;
                        infoDiv.style.display = 'block';
                    }

                    // Zatvori modal
                    document.getElementById("package-modal").classList.remove("active");
                    document.body.style.overflow = "auto";
                    document.body.style.paddingRight = "0px";

                    // Prikaži success popup
                    const popup = document.getElementById('success-popup');
                    popup.style.display = 'block';

                    // Sakrij popup nakon 3 sekunde
                    setTimeout(() => {
                        popup.style.animation = 'slideOut 0.5s ease-in forwards';
                        setTimeout(() => {
                            popup.style.display = 'none';
                            popup.style.animation = '';
                        }, 500);
                    }, 3000);
                })
                .catch(error => {
                    console.error('Error updating cart:', error);
                    const popup = document.getElementById('success-popup');
                    const popupContent = popup.querySelector('.success-popup-content');
                    const icon = popup.querySelector('.success-icon svg path');
                    const title = popup.querySelector('h3');
                    const message = popup.querySelector('p');

                    // Promeni u error stil
                    icon.style.stroke = '#f44336';
                    title.style.color = '#f44336';
                    title.textContent = 'Greška';
                    message.textContent = 'Došlo je do greške prilikom čuvanja paktemata. Molimo pokušajte ponovo.';

                    popup.style.display = 'block';

                    setTimeout(() => {
                        popup.style.animation = 'slideOut 0.5s ease-in forwards';
                        setTimeout(() => {
                            popup.style.display = 'none';
                            popup.style.animation = '';
                            // Vrati na originalni success stil
                            icon.style.stroke = '#4CAF50';
                            title.style.color = '#4CAF50';
                            title.textContent = 'Uspešno!';
                            message.textContent = 'Paketomat je uspešno odabran';
                        }, 500);
                    }, 3000);
                });
        }
    });

    async function getToken() {
        try {
            const response = await fetch('https://dxwebapi.posta.hr:9000/api/authentication/client_auth', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username: 'roranatura',
                    password: 'pSMdLmPt7aRw'
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch token');
            }

            const data = await response.json();
            return data.token;
        } catch (error) {
            console.error('Error getting token:', error);
            throw error;
        }
    }

    getToken();
});
